/* Petask urun sayfasi — Instacart duzeni (B):
   kucuk gorsel solda; ortada baslik+rozet+varyant; sagda satin alma karti.
   Ayrica: besin rozetleri, aciklama akordeonu (alt bolum), C icin yorum placeholder. */
(function () {
  if (window.__petaskPdp) return;
  window.__petaskPdp = true;


  /* MOBIL: Besin Degerleri kutusunu "Icindekiler" kutusunun ustune tasi.
     Masaustunde kutu sagda yapiskan bir sutun; izgara tek sutuna inince aside
     butun aciklamadan SONRA geliyordu ve sayfanin en dibinde kaliyordu.
     CSS ile cozulemez: kutu .petask-pdp-details__inner'in kardesi, hedef konum
     ise onun cocugu — order/flex baska bir kapsayicinin icine tasiyamaz.
     Masaustune geri donuldugunde kutu kendi yerine iade edilir.
     Bu mantik kart kurulum blogunun icindeydi; sunucu render'inda o blok
     atlandigi icin disari cikarildi. Icindekiler kutusu yoksa (orn. kedi kumu)
     hicbir sey yapmaz. */
  function petaskMobilKutu(desc) {
    var kutu = document.querySelector('.petask-nutribox');
    var icKutu = Array.from(desc.querySelectorAll('.petask-hf-box')).find(function (el) {
      var b = el.querySelector('.petask-hf-box__title');
      return b && b.textContent.indexOf('İçindekiler') !== -1;
    });
    if (!kutu || !icKutu) return;
    var yuva = kutu.parentNode;
    var sonraki = kutu.nextSibling;
    var mq = window.matchMedia('(max-width: 899px)');
    var yerlestir = function (m) {
      if (m.matches) {
        if (kutu.parentNode !== desc) icKutu.before(kutu);
      } else if (kutu.parentNode !== yuva) {
        yuva.insertBefore(kutu, sonraki);
      }
    };
    yerlestir(mq);
    mq.addEventListener('change', yerlestir);
  }

  function init() {
    var main = document.querySelector('main[data-template]');
    if (!main) return;
    var t = main.dataset.template || '';
    var variant = (t === 'product' || t.indexOf('duzen-c') !== -1) ? 'c' : t.indexOf('duzen-b') !== -1 ? 'b' : t.indexOf('duzen-a') !== -1 ? 'a' : null;
    if (!variant) return;
    document.body.classList.add('petask-pdp-' + variant);

    /* aciklama blogu: en uzun .rte/text-block (alt bolumdeki) */
    var desc = null;
    var cands = Array.from(document.querySelectorAll('main .rte, main [class*="text-block"]'));
    cands.forEach(function (el) {
      if (el.textContent.length > 400 && (!desc || el.textContent.length > desc.textContent.length)) desc = el;
    });

    /* SUNUCU RENDER'I. Bolum, custom.tasarim dolu mamalarda kart duzenini ve
       besin kutusunu Liquid'de basiyor (snippets/petask-pdp-kartlar.liquid +
       sections/petask-pdp-details.liquid) ve .petask-pdp-desc uzerine
       data-petask-sunucu="1" koyuyor. Kart kurulum ve besin kutusu bloklari
       buradan tamamen SILINDI; geriye kalan tek kosul, sunucu bir kez kurmusken
       aciklamayi ikinci kez akordeona bolmemek.
       Bugun 31/31 urunde tasarim verisi dolu; oznitelik yalnizca verisi olmayan
       yeni bir urunde eksik kalir ve o zaman eski yol yedek olarak calisir.
       DIKKAT: mobilde besin kutusunu Icindekiler kutusunun ustune tasiyan mantik
       eskiden kart blogunun icindeydi; o blok kalkinca kutu sayfanin dibinde
       kaliyordu. Mantik petaskMobilKutu()'ya cikarildi ve iki yolda da calisir. */
    var petaskSunucuda = !!(desc && desc.dataset.petaskSunucu === '1');

    /* --- Besin rozetleri: kullanici istegiyle KALDIRILDI --- */
    var strip = null;
    if (false && variant === 'b' && desc) {
      var text = desc.textContent;
      var ai = text.indexOf('Analitik');
      if (ai === -1) ai = text.indexOf('Ham Protein');
      var zone = ai !== -1 ? text.slice(Math.max(0, ai - 50), ai + 700) : text;
      var badges = [];
      [['Protein', /(?:Ham\s+)?Protein\s*:?\s*%\s*(\d+(?:[.,]\d+)?)/i],
       ['Yag', /(?:Ham\s+)?Ya\u011f\s*:?\s*%\s*(\d+(?:[.,]\d+)?)/i],
       ['Kul', /(?:Ham\s+)?K\u00fcl\s*:?\s*%\s*(\d+(?:[.,]\d+)?)/i],
       ['Seluloz', /(?:Ham\s+)?Sel\u00fcloz(?:\s*\(Lif\))?\s*:?\s*%\s*(\d+(?:[.,]\d+)?)/i]].forEach(function (p) {
        var m = zone.match(p[1]);
        if (m) badges.push([p[0], '%' + m[1]]);
      });
      var labels = { Protein: 'Protein', Yag: 'Ya\u011f', Kul: 'K\u00fcl', Seluloz: 'Sel\u00fcloz' };
      if (badges.length) {
        strip = document.createElement('div');
        strip.className = 'petask-nutri';
        strip.innerHTML = badges.map(function (b) {
          return '<div class="petask-nutri__item"><span class="petask-nutri__val">' + b[1] + '</span><span class="petask-nutri__key">' + labels[b[0]] + '</span></div>';
        }).join('');
      }
    }

    /* --- Instacart/L yerlesimi (tum varyantlar) --- */
    if (variant === 'a' || variant === 'b' || variant === 'c') {
      var vp = document.querySelector('variant-picker');
      /* bloklarin konteyneri: baslik ile sepet alaninin ORTAK ebeveyni
         (tek varyantli urunlerde variant-picker olmadigi icin anchor'dan yukari tirmanilir) */
      var anchor = vp || document.querySelector('.buy-buttons-block') || document.querySelector('product-form-component');
      var details = null;
      if (anchor) {
        var el = anchor;
        for (var ii = 0; ii < 8 && el.parentElement; ii++) {
          var par = el.parentElement;
          var h1c = par.querySelector('h1');
          if (h1c && !el.contains(h1c)) { details = par; break; }
          el = par;
        }
      }
      if (details && !details.dataset.petaskIg) {
        details.dataset.petaskIg = '1';
        var kids = Array.from(details.children);
        var wrap = document.createElement('div');
        wrap.className = 'petask-ig-wrap';
        var left = document.createElement('div');
        left.className = 'petask-ig-left';
        var buy = document.createElement('div');
        buy.className = 'petask-ig-buy';

        kids.forEach(function (el) {
          var tx = el.textContent || '';
          var isBuy = (el.classList && el.classList.contains('buy-buttons-block')) || (el.querySelector && el.querySelector('.buy-buttons-block, product-form-component, [name="add"]'));
          var isKargo = tx.indexOf('Kargo Bedava') !== -1 && tx.length < 300;
          var isVp = el.tagName === 'VARIANT-PICKER' || (el.querySelector && el.querySelector('variant-picker'));
          if (isKargo) { el.remove(); return; }
          if (isBuy || isVp) buy.appendChild(el);
          else left.appendChild(el);
        });

        /* fiyati baslik grubundan cikarip satin alma kartinin basina tasi */
        var priceEl = left.querySelector('product-price') ||
                      Array.from(left.querySelectorAll('.price')).filter(function (e) {
                        return !e.closest('.petask-chip');
                      })[0];
        if (priceEl) {
          var priceBox = priceEl.closest('div') === left ? priceEl : priceEl;
          /* fiyat + puan tek satirda */
          var priceRow = document.createElement('div');
          priceRow.className = 'petask-price-row';
          priceRow.appendChild(priceBox);
          /* YILDIZ SATIRI BURADAN KALDIRILDI (2026-07-28).
             Burada window.__petaskRating / __petaskRatingCount okunuyordu ama bu
             global'ler hicbir yerde DOLDURULMUYORDU — satir her uruende (0)
             gosteriyordu. Artik yildizlar blocks/petask-yildiz.liquid tarafindan
             SUNUCUDA, baslik ile fiyat arasinda basiliyor; kaynak Shopify'in
             standart reviews.rating / reviews.rating_count metafield'lari.
             Sunucu render'i tercih edildi cunku JS ile cizilen yildiz ham HTML'de
             gorunmuyor — arama motoru ve yapay zeka tarayicilari okuyamiyor.
             Ikisi birden acik kalirsa sayfada CELISKILI iki yildiz satiri olur
             (biri 4.3, digeri 0). priceRow korundu: yerlesim ve asagidaki
             priceRow.nextSibling kargo satiri ona bagli. */
          buy.insertBefore(priceRow, buy.firstChild);

          /* Ayni gun kargo geri sayimi (kesim: 16:30 TR; Pzt-Cmt kargo gunu) */
          var ship = document.createElement('div');
          ship.className = 'petask-shipline';
          buy.insertBefore(ship, priceRow.nextSibling);
          var updShip = function () {
            var n = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Istanbul' }));
            var day = n.getDay();
            var cut = new Date(n); cut.setHours(16, 30, 0, 0);
            if (day >= 1 && day <= 6 && n < cut) {
              var ms = cut - n;
              var h = Math.floor(ms / 3600000);
              var m = Math.floor((ms % 3600000) / 60000);
              ship.innerHTML = '🚚 <strong>' + (h > 0 ? h + ' saat ' : '') + m + ' dakika</strong> içinde sipariş verirseniz <strong>bugün</strong> kargoya verilir.';
            } else {
              var next = (day === 6 && n >= cut) ? 'Pazartesi' : 'yarın';
              ship.innerHTML = '🚚 Şimdi sipariş verirseniz <strong>' + next + '</strong> kargoya verilir.';
            }
          };
          updShip();
          setInterval(updShip, 30000);

          /* Taksit bilgisi */
          var pay = document.createElement('div');
          pay.className = 'petask-payline';
          pay.innerHTML = '💳 Kredi kartına <strong>3 taksit</strong> imkânı';
          buy.insertBefore(pay, ship.nextSibling);

          /* Indirimliyse: son 30 gunun en dusuk fiyati (TR mevzuati) */
          var updLow = function () {
            var old = buy.querySelector('.petask-lowline');
            var saleBox = buy.querySelector('.price__sale');
            var onSale = saleBox && !saleBox.classList.contains('price__hidden');
            if (!onSale) { if (old) old.remove(); return; }
            var saleP = saleBox.querySelector('.price-item--sale');
            var txt = saleP ? saleP.textContent.trim() : '';
            if (!txt) { if (old) old.remove(); return; }
            if (!old) {
              old = document.createElement('div');
              old.className = 'petask-lowline';
              priceRow.parentNode.insertBefore(old, priceRow.nextSibling);
            }
            old.innerHTML = '🏷️ Bu fiyat, <strong>son 30 günün en düşük fiyatı!</strong>';
          };
          updLow();
          document.addEventListener('change', function (e) {
            if (e.target && e.target.closest && e.target.closest('variant-picker')) setTimeout(updLow, 80);
          });
        }

        /* rozetleri basligin altina koy */
        if (strip) {
          var h1 = left.querySelector('h1');
          if (h1 && h1.parentNode) h1.parentNode.insertBefore(strip, h1.nextSibling);
          else left.insertBefore(strip, left.firstChild);
        }

        wrap.appendChild(left);
        wrap.appendChild(buy);
        details.appendChild(wrap);

        /* L3 (duzen-c): basliktan turetilen ozellik tablosu */
        if (variant === 'c') {
          var h1el = left.querySelector('h1');
          var title = h1el ? h1el.textContent : '';
          function pick(list) {
            for (var i = 0; i < list.length; i++) if (title.indexOf(list[i]) !== -1) return list[i];
            return null;
          }
          /* MARKA / TUR / FORM da artik yapisal veriden.
             Ucu de urun ADINDA kelime aranarak tahmin ediliyordu:
               marka = pick(['Bandelo','Petipure','Cresto'])
               tur   = baslikta 'Kopek' geciyor mu
               form  = pick(['Kuru','Pouch','Konserve','Kum'])
             Kaynaklari zaten kesin biliniyordu — product.vendor ve product.type —
             ve bolum bunlari data-petask-marka / -tur / -form olarak basiyor.
             Form'da yas urunlerin Pouch/Konserve ayrimi shopify.package-type
             taksonomi alanindan geliyor; ekranda gorunen deger degismedi.
             Oznitelik yoksa (eski tema surumu) eski baslik yolu yedek kalir. */
          var marka = (desc && desc.dataset.petaskMarka) ||
            pick(['Bandelo', 'Petipure', 'Cresto']) || 'Peta\u015fk';
          /* LEZZET ve YAS GRUBU ONCE METAFIELD'DAN (custom.lezzet / custom.yas_grubu;
             bolum bunlari data-petask-lezzet / data-petask-yas olarak basar).
             Eskiden ikisi de URUN ADINDA kelime arayarak tahmin ediliyordu ve bu
             sessizce yanilabiliyordu: "Bandelo Tavuklu Sebzeli ..." adinda "ve"
             olmadigi icin 'Tavuklu ve Sebzeli' eslesmiyor, kod bir alttaki
             'Tavuklu'ya dusuyordu; tabloda eksik lezzet gorunuyordu.
             Metafield bos olan urunlerde (kedi kumlari) eski baslik yolu yedek
             kalir; kumlarda zaten Lezzet/Yas yerine Koku satiri basiliyor. */
          var lezzet = (desc && desc.dataset.petaskLezzet) ||
            pick(['Tavuklu ve Sebzeli', 'Sığır ve Pirinçli', 'Tavuklu', 'Somonlu', 'Kuzu Etli', 'S\u0131\u011f\u0131r Etli', 'Bebek Pudras\u0131', 'Marsilya Sabun']) || '\u2014';
          var yas = (desc && desc.dataset.petaskYas) ||
            pick(['Yavru', 'K\u0131s\u0131rla\u015ft\u0131r\u0131lm\u0131\u015f', 'Yeti\u015fkin']) || 'T\u00fcm ya\u015flar';
          var form = (desc && desc.dataset.petaskForm) ||
            pick(['Kuru', 'Pouch', 'Konserve', 'Kum']) || (title.indexOf('Ya\u015f') !== -1 ? 'Ya\u015f mama' : '\u2014');
          if (form === 'Kuru') form = 'Kuru mama';
          if (form === 'Kum') form = 'Kedi kumu';
          var petaskTurAd = (desc && desc.dataset.petaskTur) || title;
          var tur = petaskTurAd.indexOf('K\u00f6pek') !== -1 ? 'K\u00f6pek' : 'Kedi';
          var tbl = document.createElement('table');
          tbl.className = 'petask-specs';
          var rows = '<tr><td>Marka</td><td>' + marka + '</td></tr>' +
                     '<tr><td>T\u00fcr</td><td>' + tur + '</td></tr>';
          if (form === 'Kedi kumu') {
            /* KOKU da metafield'dan (custom.tasarim.analitik icindeki "Koku"
               satiri; bolum data-petask-koku olarak basar). Eskiden urun adindan
               tahmin ediliyordu ve sagdaki Teknik Ozellikler kutusuyla CELISIYORDU:
               ayni uründe biri "Kokusuz (Dogal)", digeri "Dogal (kokusuz)" yaziyordu.
               Artik iki bolge de ayni kaynaktan besleniyor. */
            var koku = (desc && desc.dataset.petaskKoku) ||
              pick(['Bebek Pudras\u0131', 'Marsilya Sabun']) || 'Do\u011fal (kokusuz)';
            if (koku === 'Marsilya Sabun') koku = 'Marsilya Sabunu';
            rows += '<tr><td>Koku</td><td>' + koku + '</td></tr>';
          } else if (lezzet !== '\u2014') {
            rows += '<tr><td>Lezzet</td><td>' + lezzet + '</td></tr>';
            rows += '<tr><td>Ya\u015f grubu</td><td>' + yas + '</td></tr>';
          }
          rows += '<tr><td>Form</td><td>' + form + '</td></tr>';
          /* Agirlik: SECILI varyant degeri; secim degisince guncellenir */
          function selWeight() {
            var c = document.querySelector('variant-picker input[type="radio"]:checked');
            var v = (c && c.value) || (function () {
              var any = document.querySelector('variant-picker input[type="radio"]');
              return any ? any.value : '';
            })();
            /* "6 Adet" gibi degerlere paket gramajini ekle: "6 Adet × 85 g (510 g)" */
            var am = v.match(/^(\d+)\s*Adet$/i);
            var tm = title.match(/(\d+)\s*(?:gr|g)\b/i) || location.pathname.match(/(\d+)-?(?:gr|g)\b/i);
            if (am && tm) {
              var adet = parseInt(am[1], 10), gr = parseInt(tm[1], 10);
              return adet + ' Adet × ' + gr + ' g (' + (adet * gr) + ' g)';
            }
            return v;
          }
          if (selWeight()) rows += '<tr><td>Ağırlık</td><td data-petask-sel-weight>' + selWeight() + '</td></tr>';
          tbl.innerHTML = rows;
          document.addEventListener('change', function (e) {
            if (!e.target || !e.target.closest || !e.target.closest('variant-picker')) return;
            var cell = document.querySelector('[data-petask-sel-weight]');
            if (cell) setTimeout(function () { cell.textContent = selWeight(); }, 50);
          });
          var vpEl = left.querySelector('variant-picker');
          if (vpEl && vpEl.parentNode) vpEl.parentNode.insertBefore(tbl, vpEl);
          else left.appendChild(tbl);
        }
      } else if (strip && vp && vp.parentNode) {
        vp.parentNode.insertBefore(strip, vp);
      }
    }

    /* --- Akordeon (B ve C): alt bolumdeki aciklamayi H2'lere gore bol --- */
    if ((variant === 'b' || variant === 'c') && desc && !petaskSunucuda && !desc.dataset.petaskAcc) {
      desc.dataset.petaskAcc = '1';
      var dk = Array.from(desc.children);
      var firstH2 = dk.findIndex(function (el) { return el.tagName === 'H2'; });
      if (firstH2 > 0) {
        var rest = dk.slice(firstH2);
        var groups = [];
        var cur = null;
        rest.forEach(function (el) {
          if (el.tagName === 'H2') { cur = { title: el.textContent.trim(), items: [] }; groups.push(cur); }
          else if (cur) cur.items.push(el);
        });
        if (groups.length) {
          var accWrap = document.createElement('div');
          accWrap.className = 'petask-acc';
          groups.forEach(function (g, i) {
            var det = document.createElement('details');
            if (i === 0) det.open = true;
            var sum = document.createElement('summary');
            sum.textContent = g.title;
            det.appendChild(sum);
            g.items.forEach(function (el) { det.appendChild(el); });
            accWrap.appendChild(det);
          });
          rest.forEach(function (el) { if (el.parentNode === desc) desc.removeChild(el); });
          desc.appendChild(accWrap);
        }
      }
    }


    /* Mobil yerlesim: kart duzeni ister sunucuda ister burada kurulmus olsun
       calismali (bkz. petaskSunucuda notu). */
    if (desc) petaskMobilKutu(desc);

    /* --- Yorum placeholder (C) --- */
    if (variant === 'c' && !document.querySelector('.petask-reviews-ph')) {
      var ph = document.createElement('div');
      ph.className = 'petask-reviews-ph';
      ph.innerHTML = '<h2>De\u011ferlendirmeler</h2><div class="petask-reviews-ph__box">Hen\u00fcz de\u011ferlendirme yok \u2014 ilk yorumu siz yaz\u0131n! \u2b50</div>';
      var recs = document.querySelector('[id*="product_recommendations"], .product-recommendations');
      if (recs && recs.parentNode) recs.parentNode.insertBefore(ph, recs);
      else main.appendChild(ph);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* --- TEMA EDİTÖRÜ DESTEĞİ ---
     Editörde bir ayar değiştirildiğinde Shopify yalnızca o bölümün HTML'ini
     yeniden basar. Bu script sadece DOMContentLoaded'da çalıştığı için yeniden
     basılan bölümde besin kutusu boş kalıyor, malzeme kartları hiç oluşmuyordu.

     init()'i tekrar ÇAĞIRMAK ÇÖZÜM DEĞİL: init() tüm sayfayı yeniden düzenliyor
     (variant-picker'ı taşıyor, satır 219/281/880'de global 'change' dinleyicileri
     ekliyor). Tekrar çalıştırıldığında bu dinleyiciler çoğalıyor ve YUKARIDAKİ
     "ürün bilgileri" bölümü bozuluyor — kullanıcı bunu bildirdi.

     Bu yüzden editörde tam sayfa yenileme yapıyoruz: garantili doğru sonuç.
     Kaydırıcı sürüklerken üst üste yenilenmesin diye 700 ms geciktiriliyor.
     YALNIZCA editörde çalışır (Shopify.designMode) — canlı sitede maliyeti yok. */
  var editorYenilemeZamani;
  document.addEventListener('shopify:section:load', function (e) {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    var hedef = e.target;
    if (!hedef || !hedef.querySelector) return;
    if (!hedef.querySelector('[data-petask-nutribox], .petask-pdp-desc')) return;
    clearTimeout(editorYenilemeZamani);
    editorYenilemeZamani = setTimeout(function () { window.location.reload(); }, 700);
  });

  /* ===== VARSAYILAN GRAMAJ (urun sayfasi) =====
     Kartlar ve One cikan panel custom.varsayilan_varyant'i Liquid'de okuyor.
     Urun sayfasinin secicisi ise Shopify'in selected_or_first_available_variant'ina
     bagli; Liquid'den ezilemiyor. Bu yuzden acilista dogru radyoyu TIKLIYORUZ —
     temanin kendi mekanizmasi calistigi icin fiyat, gorsel, form ve yapiskan cubuk
     hep birlikte guncelleniyor (elle senkron gerekmiyor).
     Kurallar: URL'de ?variant= varsa dokunma (kullanici/kampanya linki kazanir),
     zaten dogru gramaj seciliyse dokunma, sadece BIR kez calis. */
  function varsayilanGramaj() {
    if (new URLSearchParams(location.search).has('variant')) return;
    var kaynak = document.querySelector('[data-petask-varsayilan-varyant]');
    if (!kaynak) return;
    var hedefId = kaynak.getAttribute('data-petask-varsayilan-varyant');
    if (!hedefId) return;

    var radyolar = document.querySelectorAll('variant-picker input[type="radio"][data-variant-id]');
    if (!radyolar.length) return;

    var secili = null, hedef = null;
    radyolar.forEach(function (r) {
      if (r.checked) secili = r;
      if (r.getAttribute('data-variant-id') === hedefId) hedef = r;
    });
    if (!hedef || hedef === secili) return;
    if (hedef.getAttribute('data-option-available') === 'false') return;

    var etiket = hedef.closest('label');
    (etiket || hedef).click();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', varsayilanGramaj, { once: true });
  } else {
    varsayilanGramaj();
  }
})();
